import { windowStorage, WindowStorageToken } from '../../../windowStorage';

export const BaseUrl = () => {
    return '/api/beneficiary-support-panel';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function get(url): Promise<any> {
    return fetch(url, {
        method: 'GET',
        headers: jsonHeaders(),
    });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function post(url, body): Promise<any> {
    return fetch(url, {
        method: 'POST',
        headers: jsonHeaders(),
        body: JSON.stringify(body),
    });
}

export function fetch(url: string, requestInit: RequestInit) {
    return window.fetch(url, requestInit).then(async (response) => {
        if (response.status < 200 || response.status >= 300) {
            // Create an error object that the error middleware can handle
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error: any = new Error(`HTTP ${response.status}`);
            error.status = response.status;
            error.statusText = response.statusText;
            try {
                const body = await response.json();
                error.body = body;
                error.message = body.message || error.message;
            } catch (e) {
                error.message = response.statusText || error.message;
            }
            throw error;
        }
        if (response.status !== 204) {
            return response.json();
        }
        return response;
    });
}

function jsonHeaders() {
    return new Headers(
        Object.assign(
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            authHeaders()
        )
    );
}

function authHeaders() {
    const stored = windowStorage.getItem(WindowStorageToken.partnerUserApiToken) || '';
    if (!stored) {
        return { Authorization: '' };
    }
    const header = /^Bearer\s+/i.test(stored) ? stored : `Bearer ${stored}`;
    return {
        Authorization: header,
    };
}
